import React, { useEffect, useState } from 'react';
import { useGlobal } from 'reactn';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import useOnclickOutside from "react-cool-onclickoutside";
import { SlideDown } from 'react-slidedown';

import { UI_LANGUAGE } from 'stores/const';

const SiteFooter = () => {

    const { t, i18n } = useTranslation(['sitefooter']);

    const [openMenu, setOpenMenu] = useState(false);
    const handleBtnClick = () => setOpenMenu(!openMenu);
    const closeMenu = () => setOpenMenu(false);
    const langRef = useOnclickOutside(() => closeMenu());

    const [masterData] = useGlobal('masterData');
    const [lessorProps, setLessorProps] = useState(null);

    const LanguageAnchor = ({ langCode }) => {
        const LANG_COOKIES = {
            de: "de-CH",
            en: "en-US",
            fr: "fr-CH",
            it: "it-IT",
            cs: "cs-CZ"
        }
        const onChangeLanguage = (e, langCode) => {
            e.preventDefault();
            const newLang = LANG_COOKIES[langCode];
            const cookieValue = `c=${newLang}|uic=${newLang}`;
            Cookies.set("origamCurrentLocale", cookieValue, { expires: 365, path: '/' })
            Cookies.set("origamLanguage", newLang, { expires: 365, path: '/' })
            i18n.changeLanguage(langCode);
            closeMenu();
            document.location.reload();
        }
        return (
            <div>
                <a className="language-dropdown-item" onClick={(e) => onChangeLanguage(e, langCode)}>
                    {UI_LANGUAGE[langCode]}
                </a>
            </div>
        )
    }

    useEffect(() => {
        const getLessorProps = async () => {
            const org = masterData.organization;
            const hbu = org.DefaultBusinessUnit[0];
            const phone = hbu.Mobile || hbu.Phone;
            setLessorProps({
                name: org.Name,
                agbLink: `/api/public/BusinessUnit/${hbu.Id}/getCurrentGTC`,
                impLink: org.LegalNoticeLink,
                phone,
                email: hbu.Email
            })
        }
        getLessorProps();
      }, []);

    return (
        <footer className="footer-container">
            <div className="wrapper">
                <div className="row">
                    <div className="column-3">
                        <img className="icon-container" src="/clients/standard/release/assets/content/logos/wyby-icon.svg" />
                        <h2 className="claim">
                            {t("claimText1")}
                            <br />
                            {t("claimText2")}
                        </h2>
                    </div>
                    <div className="column-3 offset-6">
                        <div className="language-dropdown">
                            <div ref={langRef}>
                                <a className="language small" onClick={handleBtnClick}>
                                    {UI_LANGUAGE[i18n.language]} <i className="fa fa-caret-down" aria-hidden="true"></i>
                                </a>
                            </div>
                            <SlideDown className={'wy-dropdown'}>
                                {openMenu && (<div className="language-dropdown-menu ignore-onclickoutside">
                                    <LanguageAnchor langCode="de" />
                                    <LanguageAnchor langCode="en" />
                                    <LanguageAnchor langCode="fr" />
                                    <LanguageAnchor langCode="it" />
                                </div>
                                )}
                            </SlideDown>
                        </div>
                        <a className="help small" href="https://wyby.ch/de-ch/Support/Anleitung" target="_blank"><i className="fa fa-question" aria-hidden="true"></i></a>
                    </div>
                </div>
                <div className="row footer-copyright">
                    <div className="column-3">
                        <ul>
                            <li><a href="https://wyby.ch/" target="_blank">© 2017 wy.by ag</a></li>
                            {/* <li><a href="https://wyby.ch/de-ch/Haftungsauschluss" target="_blank">Impressum</a></li> */}
                        </ul>
                    </div>
                    {lessorProps && <div className="column-9">
                        <ul>
                            <li><a href={lessorProps.agbLink} target="_blank">{lessorProps.name} {t("agb")}</a></li>
                            <li><a href={lessorProps.impLink} target="_blank">Impressum</a></li>
                            <li><a href={`tel:${lessorProps.phone}`} target="_blank">{lessorProps.phone}</a></li>
                            <li><a href={`mailto:${lessorProps.email}`} target="_blank">{lessorProps.email}</a></li>
                        </ul>
                    </div> }                   
                </div>
            </div>
        </footer>
    );
}

export default SiteFooter;